import { ExportFormatKey } from "@/enums/fees_enum.ts";

/**
 * Find the filename from Content-Disposition header.
 * Supports both "filename*" (RFC 5987) and classic "filename".
 */
function parseFilenameFromContentDisposition(
  contentDisposition: string | undefined,
  defaultFilename: string
): string {
  if (!contentDisposition) return defaultFilename;

  const stripQuotes = (s: string): string => s.replace(/^['"]|['"]$/g, '').trim();

  // 1) filename* (RFC 5987) - ex: filename*=UTF-8''Mes_frais_2025-01-01.csv
  const filenameStarMatch = contentDisposition.match(/filename\*\s*=\s*([^;]+)/i);
  if (filenameStarMatch && filenameStarMatch[1]) {
    let raw = stripQuotes(filenameStarMatch[1]);
    // Remove encoding info if present
    const starParts = raw.split("''");
    if (starParts.length > 1) {
      raw = starParts.slice(1).join("''");
    }
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }

  // 2) filename - ex: filename="Mes_frais_2025-01-01.csv"
  const filenameMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i);
  if (filenameMatch && filenameMatch[1]) {
    return stripQuotes(filenameMatch[1]);
  }

  return defaultFilename;
}

/**
 * Trigger a file download in the browser with the given data and filename.
 */
export function triggerExportFileDownload(
  contentDisposition: string | undefined,
  period: string,
  dataFile: BlobPart,
  exportFormat: ExportFormatKey
): void {
  const defaultFilename = `Mes_frais_${period}.${exportFormat.toLowerCase()}`;
  const filename = parseFilenameFromContentDisposition(contentDisposition, defaultFilename);

  const blob: Blob = new Blob([dataFile]);
  const url: string = window.URL.createObjectURL(blob);
  const link: HTMLAnchorElement = document.createElement('a');

  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}